
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/small-business",
      function () {
        return require("private-next-pages/small-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/small-business"])
      });
    }
  